export const heroTraining = [
    {
        session: 'Hero Training Summer 2022',
        location: 'On-Campus',
        dates: 'May 22nd - June 23rd, 2023',
        duration: '5 Weeks',
        deadline: '05/02/2022',
    },
    {
        session: 'Hero Training Fall 2022',
        location: 'On-Campus',
        dates: 'Ocotber 9th - November 10th, 2023',
        duration: '5 Weeks',
        deadline: '09/12/2022',
    },
];
export const fundamentalForm = [{
    session: 'Fundamentals of Entrepreneurship',
    location: 'Virtual ',
    dates: 'April 4 - April 18, 2023',
    duration: '5 Weeks',
    deadline: '05/02/2022',
}];
export const houseofCeek = [{
    session: 'House of CEEK',
    location: 'On campus ',
    dates: ' Summer 2023',
    duration: '4 weeks',
    deadline: ' Summer 2023',
}];
export const kanooInnovationHub = [{
    session: 'Kanoo Innovation Hub',
    location: 'On campus ',
    dates: ' Summer 2023',
    duration: '4 weeks',
    deadline: ' Summer 2023',
}];
export const CorporateInnovation = [{
    session: 'Corporate Innovation Program',
    location: 'On campus ',
    dates: ' Summer 2023',
    duration: '4 weeks',
    deadline: ' Summer 2023',
}];
export const BlockchainAccelerators = [{
    session: 'Blockchain Accelerators Program',
    location: 'On campus ',
    dates: ' Summer 2023',
    duration: '4 weeks',
    deadline: ' Summer 2023',
}];
export const CorporateAccelerators = [{
    session: 'Corporate Accelerators Program',
    location: 'On campus ',
    dates: ' Summer 2023',
    duration: '4 weeks',
    deadline: ' Summer 2023',
}];
